<template>
<div class="container">
    <el-card class="box-card">
      <div style="margin-top:50px;text-align:center">
         <img width="80px" src="@/assets/logo.jpg" />
      </div>
    <h3 style="text-align:center;">喵星君大大四柱八字排盘</h3>
    <el-divider />
    <!-- <el-form ref="sizeForm" :rules="rules" :model="sizeForm" label-width="100px" label-position="top" label-suffix=":" >
        <el-form-item label="出生时辰" prop="date1">
            <el-row>
              <el-col :span="11">
                <el-form-item prop="date1">
                  <el-date-picker type="date" value-format="yyyy-M-d" placeholder="请选阳历生日" v-model="sizeForm.date1" style="width: 100%;"></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="2">
                  <div style="text-align:center">-</div>
              </el-col>
              <el-col :span="11">
                <el-form-item prop="date2">
                  <el-time-picker placeholder="出生时间" value-format="HH-mm-ss" v-model="sizeForm.date2" style="width: 100%;"></el-time-picker>
                </el-form-item>
              </el-col>
              </el-row>
        </el-form-item>
        <el-form-item label="出生地点" prop="province">
            <el-col :span="11">
                <el-form-item prop="province">
                    <el-select filterable style="width: 100%;" v-model="sizeForm.province" placeholder="请选省份">
                        <el-option
                          v-for="item in provinceList"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="2">
                <div style="text-align:center">-</div>
              </el-col>
              <el-col :span="11">
                <el-form-item prop="city">
                    <el-select filterable style="width: 100%;" v-model="sizeForm.city" placeholder="请选城市">
                        <el-option
                          v-for="item in cityFilterList"
                          :key="item"
                          :label="item"
                          :value="item">
                        </el-option>
                      </el-select>
                </el-form-item>
              </el-col>
          </el-form-item>
        <el-form-item label="性别" prop="sex">
        <el-col :span="11">
         <el-radio-group v-model="sizeForm.sex" style="width: 100%;" placeholder="请选择性别">
           <el-radio label="男"></el-radio>
           <el-radio label="女"></el-radio>
        </el-radio-group>
        </el-col>
        </el-form-item>
        <div style="margin-top: 30px;text-align:center">
        <el-button type="primary" icon="el-icon-check" style="width:100%" @click="submitForm('sizeForm')">提交</el-button>
        </div>
     </el-form> -->
      <van-form  @submit="onSubmit">
         <!-- 时间选择器-->
        <van-field
          readonly
          clickable
          name="datetimePicker"
          :value="datetime"
          label="出生时间选择"
          placeholder="点击选择时间"
          style="margin:30px 0px"
          @click="showPicker2 = true"
        />
        <van-popup v-model="showPicker2" position="bottom">
          <van-datetime-picker
            type="datetime"
            v-model="currentDate"
            title="选择完整时间"
            :min-date="minDate"
            :max-date="maxDate"
            @confirm="onConfirmTime"
            @cancel="showPicker2 = false"
          />
        </van-popup>
        <!-- 地区选择器-->
        <van-field
          readonly
          clickable
          name="area"
          style="margin:30px 0px"
          :value="provincecity"
          label="出生地区选择"
          placeholder="点击选择省市区"
          @click="showArea = true"
        />
        <van-popup v-model="showArea" position="bottom">
          <van-area
            :area-list="areaList"
            :columns-num="2"
            @confirm="onConfirmCity"
            @cancel="showArea = false"
          />
        </van-popup>
         <!-- 性别选择器-->
        <van-field style="margin:30px 0px" name="radio" label="性别选择">
          <template #input>
            <van-radio-group v-model="sex" direction="horizontal">
              <van-radio name="女">女生</van-radio>
              <van-radio name="男">男生</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <div style="margin: 16px;">
          <van-button round block type="info" native-type="submit">提交</van-button>
        </div>
      </van-form>
      <div style="text-align:center;margin-top:16px">
         <el-button type="text" @click="gotoRecord">排盘记录</el-button>
      </div>
    </el-card>
</div>
</template>

<script>
import {postAction} from '@/api/manage'
import { Toast } from 'vant';
import { areaList } from '@vant/area-data';
export default {
  name: 'Home',
  data(){
    return {
            provinceList:[{value:0,label:'北京'}, {value:1,label:'上海'},{value:2,label:'天津'},{value:3,label:'重庆'},
            {value:4,label:'浙江'},{value:5,label:'香港'},{value:6,label:'澳门'},{value:7,label:'台湾'},{value:8,label:'河北'},
            {value:9,label:'内蒙古'}, {value:10,label:'辽宁'},{value:11,label:'山西'},{value:12,label:'吉林'},
            {value:13,label:'黑龙江'},{value:14,label:'江苏'},{value:15,label:'安徽'},{value:16,label:'福建'},
            {value:17,label:'江西'},{value:18,label:'山东'},{value:19,label:'河南'},{value:20,label:'湖北'},
            {value:21,label:'湖南'},{value:22,label:'海南'},{value:23,label:'广西'},{value:24,label:'四川'},
            {value:25,label:'贵州'},{value:26,label:'云南'},{value:27,label:'陕西'},{value:28,label:'甘肃'},
            {value:29,label:'青海'},{value:30,label:'新疆'},{value:31,label:'广东'}],
            cityList:[
            ["北京",  "平谷",  "密云",  "顺义",  "通县",  "怀柔",  "大兴",  "房山",  "延庆", "昌平"],
            ["上海",  "嘉定",  "宝山",  "川沙",  "南汇",  "奉贤",  "松江",  "金山",  "青浦",  "崇明"],
            ["天津",  "宁河",  "静海",  "蓟县",  "宝坻",  "武清"],
            ["重庆",  "綦江",  "长寿",  "南桐",  "合川",  "潼南",  "铜梁",  "壁山",  "荣昌",  "大足",  "永川",  "万盛"],
            ["杭州",  "余杭",  "富阳",  "建德",  "临安",  "萧山",  "桐庐",  "淳安",  "宁波",  "镇海",  "温州",  "瓯海",  "永喜",  "洞头",  "平阳",  "泰顺",  "乐清",  "瑞安",  "文成",  "苍南",  "湖州",  "平湖",  "桐乡",  "安吉",  "嘉善",  "嘉兴",  "海盐",  "海宁",  "德清",  "长兴",  "定海",  "岱山",  "嵊四",  "普陀",  "鄞县",  "象山",  "奉化",  "慈溪",  "宁海",  "余姚",  "绍兴",  "新昌",  "诸暨",  "上虞",  "嵊县",  "椒江",  "临海",  "三门",  "温岭",  "仙居",  "天台",  "黄岩",  "玉环",  "丽水",  "青田",  "庆无",  "遂昌",  "缙云",  "云和",  "龙泉",  "松阳",  "金华",  "浦江",  "东阳",  "武义",  "江山",  "开化",  "衢州",  "兰溪",  "义乌",  "永康",  "常山"],
            ["香港"],  ["澳门"],
            ["台北",  "高雄",  "基隆",  "台中",  "台南",  "宜兰",  "桃园",  "新竹"],
            ["石家庄",  "唐山",  "行唐",  "灵寿",  "束鹿",  "晋县",  "藁城",  "高邑",  "赵县",  "井陉",  "获鹿",  "新乐",  "正定",  "深泽",  "无极",  "赞皇",  "元氏",  "栾城",  "平山",  "邯郸",  "永年",  "曲周",  "馆陶",  "魏县",  "成安",  "大名",  "涉县",  "鸡泽",  "丘县",  "广平",  "肥乡",  "临漳",  "磁县",  "武安",  "邢台",  "柏乡",  "宁普",  "隆尧",  "临西",  "南官",  "巨鹿",  "任县",  "沙河",  "临城",  "内丘",  "新河",  "清河",  "威县",  "广宗",  "平乡",  "南和",  "保定",  "涞水",  "涿县",  "定兴",  "容城",  "安新",  "蠡县",  "博野",  "定县",  "阜平",  "唐县",  "涞源",  "易县",  "新城",  "雄县",  "徐水",  "高阳",  "安国",  "清苑",  "望都",  "曲阳",  "完县",  "满城",  "张家口",  "康保",  "赤城",  "怀来",  "蔚县",  "宣化",  "张北",  "沽源",  "崇礼",  "涿鹿",  "阳原",  "怀安",  "尚义",  "万全",  "承德",  "围场",  "平泉",  "宽城",  "兴隆",  "滦平",  "隆化",  "青龙",  "丰宁",  "秦皇岛",  "迁西",  "迁安",  "昌黎",  "卢龙",  "滦南",  "玉田",  "唐海",  "遵化",  "抚宁",  "乐亭",  "滦县",  "丰南",  "丰润",  "廊坊",  "安次",  "三河",  "香河",  "霸县",  "固安",  "大城",  "文安",  "永清",  "大厂",  "沧州",  "黄骅",  "盐山",  "吴桥",  "东光",  "肃宁",  "河间",  "泊头",  "交河",  "青县",  "海兴",  "南皮",  "任丘",  "献县",  "孟村",  "衡水",  "饶阳",  "阜城",  "景县",  "枣强",  "深县",  "安平",  "武强",  "武邑",  "故城",  "冀县"],
            ["呼和浩特",  "上默特左旗",  "托克托",  "包头",  "上默特右旗",  "固阳",  "乌海",  "集宁",  "兴和",  "清水河",  "武川",  "卓资",  "商都",  "丰镇",  "凉城",  "和林格尔",  "化德",  "察哈尔右翼后旗",  "察哈尔右翼中旗",  "察哈尔右翼前旗",  "四子王旗",  "达尔罕茂明安联合旗",  "二连浩特",  "阿巴哈纳尔旗",  "多伦",  "阿巴嘎旗",  "西乌珠穆沁旗",  "东乌珠穆沁旗",  "苏尼特左旗",  "苏尼特右旗",  "太仆寺旗",  "正镶白旗",  "正蓝旗",  "镶黄旗",  "海拉尔",  "满洲里",  "陈巴尔虎旗",  "额尔古纳右旗",  "额尔古纳左旗",  "喜桂图旗",  "阿荣旗",  "布特哈旗",  "新巴尔虎左旗",  "新巴尔虎右旗",  "鄂伦春自治旗",  "莫力达瓦达斡尔族自治旗",  "鄂温克族自治旗",  "通辽",  "开鲁",  "科尔沁左翼后旗",  "科尔沁左翼中旗",  "库伦旗",  "奈曼旗",  "扎鲁特旗",  "赤峰",  "宁城",  "林西",  "喀喇沁旗",  "敖汉旗",  "翁牛特旗",  "巴林右旗",  "巴林左旗",  "阿鲁科尔沁旗",  "克什克腾旗",  "伊克昭盟",  "东胜县",  "准格尔旗",  "乌审旗",  "伊金霍洛旗",  "鄂托克旗",  "鄂托克前旗",  "杭锦旗",  "达拉特旗",  "临河",  "五原",  "磴口",  "杭锦后旗",  "乌拉特中旗",  "乌拉特前旗",  "乌拉特后旗",  "阿拉善左旗",  "阿拉善右旗",  "额济纳旗",  "乌兰浩特",  "突泉",  "科尔沁右翼前旗",  "科尔沁右翼中旗"],
            ["沈阳",  "新民",  "辽中",  "大连",  "金县",  "复县",  "新金",  "庄河",  "长海",  "鞍山",  "海城",  "台安",  "抚顺",  "新宾",  "清原",  "本溪",  "垣仁",  "锦州",  "锦县",  "义县",  "黑山",  "北镇",  "锦西",  "兴城",  "绥中",  "丹东",  "东沟",  "岫岩",  "凤城",  "宽甸",  "阜新",  "彰武",  "营口",  "盖县",  "盘山",  "大洼",  "辽阳",  "灯塔",  "铁岭",  "开原",  "昌图",  "铁法",  "康平",  "法库",  "西丰",  "朝阳",  "建昌",  "北票",  "凌源",  "建平"],
            ["太原",  "阳曲",  "娄烦",  "清徐",  "大同",  "阳泉",  "长治",  "天镇",  "灵丘",  "怀仁",  "山阴",  "平鲁",  "右玉",  "阳高",  "广灵",  "浑源",  "应县",  "朔县",  "左云",  "忻县",  "代县",  "五台",  "静乐",  "保德",  "河曲",  "神池",  "原平",  "繁峙",  "定襄",  "岢岚",  "五寨",  "偏关",  "宁武",  "榆次",  "昔阳",  "左权",  "太谷",  "平遥",  "灵石",  "寿阳",  "平定",  "和顺",  "榆社",  "祁县",  "介休",  "离石",  "兴县",  "方由",  "岚县",  "交城",  "文水",  "汾阳",  "孝义",  "交口",  "石楼",  "中阳",  "临县",  "柳林",  "襄垣",  "黎城",  "壶关",  "高平",  "阳城",  "长子",  "沁源",  "潞城",  "武乡",  "平顺",  "陵川",  "晋城",  "沁水",  "屯留",  "沁县",  "临汾",  "汾西",  "安泽",  "古县",  "翼城",  "曲沃",  "吉县",  "大宁",  "侯马",  "永和",  "洪洞",  "霍县",  "浮山",  "襄汾",  "乡宁",  "蒲县",  "运城",  "闻喜",  "垣曲",  "芮城",  "临猗",  "新绛",  "河津",  "夏县",  "绛县",  "平陆",  "永济",  "万荣",  "稷山"],
            ["长春",  "吉林",  "农安",  "德惠",  "榆树",  "九台",  "双阳",  "永吉",  "舒兰",  "蛟河",  "桦甸",  "磐石",  "延吉",  "汪清",  "珲春",  "图们",  "和龙",  "安图",  "敦化",  "通化",  "柳河",  "海龙",  "辉南",  "靖宇",  "浑江",  "抚松",  "集安",  "长白",  "四平",  "梨树",  "怀德",  "伊通",  "辽源",  "东丰",  "双辽",  "白城",  "大安",  "扶余",  "乾安",  "长岭",  "通榆",  "洮安"],
            ["哈尔滨",  "齐齐哈尔",  "鹤岗",  "双鸭山",  "鸡四",  "大庆",  "伊春",  "嘉荫",  "铁力",  "绥化",  "绥棱",  "海伦",  "庆安",  "兰西",  "肇东",  "肇州",  "肇源",  "安达",  "明水",  "青岗",  "望奎",  "黑河",  "爱辉",  "德都",  "通北",  "北安",  "孙吴",  "逊克",  "嫩江",  "佳木斯",  "桦川",  "萝北",  "绥滨",  "富锦",  "同江",  "抚远",  "饶河",  "七台河",  "宝清",  "集贤",  "勃利",  "桦南",  "依兰",  "汤源",  "牡丹江",  "林口",  "鸡东",  "密山",  "虎林",  "绥芬河",  "东宁",  "穆棱",  "宁安",  "海林",  "阿城",  "呼兰",  "巴彦",  "宾县",  "木兰",  "通河",  "方正",  "延寿",  "尚志",  "五常",  "双城",  "富裕",  "讷河",  "克山",  "克东",  "拜泉",  "依安",  "林甸",  "泰来",  "龙江",  "甘南",  "杜尔伯特",  "加格达奇",  "呼玛",  "塔河",  "漠河"],
            ["南京",  "江宁",  "六合",  "江浦",  "徐州",  "连云港",  "苏州",  "无锡",  "常州",  "丰县",  "沛县",  "赣榆",  "东海",  "新沂",  "邳县",  "睢宁",  "铜山",  "清江",  "灌云",  "灌南",  "沭阳",  "宿迁",  "泗阳",  "盱眙",  "涟水",  "淮阴",  "淮安",  "洪泽",  "泗洪",  "金湖",  "盐城",  "滨海",  "阜宁",  "射阳",  "建湖",  "响水",  "大丰",  "东台",  "海安",  "如皋",  "如东",  "启东",  "海门",  "南通",  "扬州",  "宝应",  "兴化",  "高邮",  "泰兴",  "泰县",  "泰州",  "靖江",  "江都",  "邗江",  "仪征",  "镇江",  "丹徒",  "扬中",  "丹阳",  "武进",  "宜兴",  "金坛",  "溧阳",  "句容",  "溧水",  "高淳",  "江阴",  "沙洲",  "常熟",  "太仓",  "昆山",  "吴县",  "吴江"],
            ["合肥",  "长丰",  "淮南",  "凤台",  "淮北",  "濉溪",  "芜湖",  "铜陵",  "蚌埠",  "马鞍山",  "安庆",  "宿州",  "宿县",  "砀山",  "萧县",  "吴壁",  "泗县",  "五河",  "固镇",  "怀远",  "滁州",  "嘉山",  "天长",  "来安",  "全椒",  "定远",  "凤阳",  "巢湖",  "巢县",  "肥东",  "含山",  "和县",  "无为",  "卢江",  "宣城",  "当涂",  "郎溪",  "广德",  "泾县",  "南陵",  "繁昌",  "宁国",  "青阳",  "屯溪",  "休宁",  "旌得",  "绩溪",  "歙县",  "祁门",  "黟县",  "太平",  "石台",  "桐城",  "纵阳",  "怀宁",  "望江",  "宿松",  "太湖",  "岳西",  "潜山",  "东至",  "贵池",  "六安",  "霍丘",  "寿县",  "肥西",  "舒城",  "霍山",  "金寨",  "阜阳",  "毫县",  "涡阳",  "蒙城",  "利辛",  "颖上",  "阜南",  "临泉",  "界首",  "太和"],
            ["福州",  "闽侯",  "厦门",  "同安",  "南平",  "建瓯",  "浦城",  "邵武",  "顺昌",  "崇安",  "光泽",  "松溪",  "政和",  "宁德",  "福安",  "连江",  "福鼎",  "霞浦",  "吉田",  "罗源",  "寿宁",  "周宁",  "屏南",  "柘荣",  "莆田",  "仙游",  "福清",  "长乐",  "永泰",  "平潭",  "闽清",  "泉州",  "晋江",  "南安",  "惠安",  "安溪",  "永春",  "德化",  "金门",  "漳州",  "龙海",  "漳浦",  "诏安",  "平和",  "云霄",  "南靖",  "长泰",  "东山",  "华安",  "龙岩",  "上杭",  "永定",  "长汀",  "武平",  "连城",  "漳平",  "三明",  "龙溪",  "宁化",  "大田",  "永安",  "沙县",  "将乐",  "清流",  "建宁",  "泰宁",  "明溪"],
            ["南昌",  "新建",  "景德镇",  "萍乡",  "九江",  "彭泽",  "湖口",  "都昌",  "星子",  "永修",  "德安",  "瑞昌",  "武宁",  "修永",  "上饶",  "婺源",  "德兴",  "玉山",  "广丰",  "铅山",  "横峰",  "鹰潭",  "贵溪",  "余江",  "万年",  "乐平",  "波阳",  "于干",  "弋阳",  "宜春",  "万载",  "铜鼓",  "宜丰",  "上高",  "安义",  "奉新",  "高安",  "丰城",  "新余",  "分宜",  "靖安",  "抚州",  "临川",  "金溪",  "资溪",  "黎川",  "南丰",  "南城",  "宜黄",  "崇仁",  "乐安",  "进贤",  "吉安",  "新干",  "峡江",  "吉水",  "永丰",  "泰和",  "万安",  "遂川",  "宁冈",  "永新",  "莲花",  "安福",  "井冈山",  "赣州",  "广昌",  "石城",  "宁都",  "兴国",  "于都",  "瑞金",  "会昌",  "安远",  "寻乌",  "定南",  "龙南",  "全南",  "信丰",  "赣县",  "南康",  "上犹",  "崇义",  "大余"],
            ["济南",  "历城",  "长清",  "章丘",  "青岛",  "崂山",  "胶南",  "即墨",  "胶县",  "淄博",  "枣庄",  "滕县",  "东营",  "垦利",  "利津",  "德州",  "宁津",  "乐陵",  "商河",  "济阳",  "禹城",  "夏津",  "陵县",  "庆云",  "临邑",  "齐河",  "平原",  "武城",  "滨州",  "滨县",  "广饶",  "桓台",  "邹平",  "阳信",  "沾化",  "博兴",  "高青",  "惠民",  "无棣",  "潍坊",  "潍县",  "平度",  "诸城",  "安丘",  "临朐",  "寿光",  "昌邑",  "高密",  "五莲",  "昌乐",  "高都",  "烟台",  "牟平",  "文登",  "海阳",  "莱阳",  "栖霞",  "掖县",  "长岛",  "威海",  "福山",  "荣成",  "乳山",  "莱西",  "招远",  "黄县",  "蓬莱",  "临沂",  "沂水",  "日照",  "临沭",  "仓山",  "平邑",  "沂源",  "沂南",  "营县",  "莒南",  "郯城",  "费县",  "蒙阴",  "泰安",  "莱芜",  "肥城",  "平阴",  "新汶",  "新泰",  "宁阳",  "东平",  "济宁",  "兖州",  "泗水",  "鱼台",  "嘉祥",  "汶上",  "曲阜",  "邹县",  "微山",  "金乡",  "荷泽",  "郓城",  "巨野",  "单县",  "曹县",  "鄄城",  "梁山",  "成武",  "定陶",  "东明",  "聊城",  "高唐",  "东阿",  "莘县",  "临清",  "茌平",  "阳谷",  "冠县"],
            ["郑州",  "荥阳",  "开封",  "平顶山",  "洛阳",  "焦作",  "鹤壁",  "杞县",  "尉氏",  "新郑",  "登封",  "通许",  "中牟",  "密县",  "巩县",  "兰考",  "新乡",  "汲县",  "封丘",  "获嘉",  "温贺",  "济源",  "博爱",  "辉县",  "延津",  "原阳",  "武陟",  "孟县",  "沁阳",  "修武",  "安阳",  "南乐",  "范县",  "台前",  "滑县",  "浚县",  "淇县",  "内黄",  "清丰",  "濮阳",  "长垣",  "汤阴",  "林县",  "商丘",  "夏邑",  "柘城",  "睢县",  "虞城",  "永城",  "宁陵",  "民权",  "周口",  "商水",  "扶沟",  "鹿邑",  "淮阳",  "沈丘",  "西华",  "太康",  "郸城",  "项城",  "许昌",  "鄢县",  "郾城",  "襄城",  "鲁山",  "郏县",  "漯河",  "长葛",  "临颖",  "舞阳",  "叶县",  "宝丰",  "禹县",  "驻马店",  "确山",  "西平",  "汝南",  "新蔡",  "泌阳",  "遂平",  "上蔡",  "平舆",  "正阳",  "信阳",  "息县",  "固始",  "潢川",  "新县",  "罗山",  "淮滨",  "商城",  "光山",  "南阳",  "方城",  "唐河",  "新野",  "邓县",  "淅川",  "南召",  "社旗",  "桐柏",  "镇平",  "内乡",  "西峡",  "三门峡",  "孟津",  "临汝",  "汝阳",  "嵩县",  "栾川",  "灵宝",  "渑池",  "义马",  "偃师",  "伊川",  "宜阳",  "洛宁",  "卢氏",  "陕县",  "新安"],
            ["武汉",  "武昌",  "汉阳",  "黄石",  "十堰",  "沙市",  "宜昌",  "襄樊",  "孝感",  "黄陂",  "汉川",  "云梦",  "应山",  "大悟",  "应城",  "安陆",  "鄂城",  "黄冈",  "新洲",  "红安",  "麻城",  "罗川",  "浠水",  "蕲春",  "黄梅",  "广济",  "英山",  "咸宁",  "阳新",  "通山",  "通城",  "嘉鱼",  "崇阳",  "蒲圻",  "荆门",  "江陵",  "钟祥",  "京山",  "监利",  "石首"],
            ["长沙",  "望城",  "株洲",  "湘潭",  "邵阳",  "岳阳",  "临湘",  "平江",  "泪罗",  "湘阴",  "华容",  "浏阳",  "醴陵",  "攸县",  "茶陵",  "酃县",  "湘乡",  "郴州",  "郴县",  "安仁",  "永兴",  "资兴",  "桂东",  "汝城",  "宜章",  "临武",  "嘉禾",  "桂阳",  "来阳",  "衡南",  "衡山",  "衡东",  "常宁",  "祁阳",  "祁东",  "衡阳",  "永州",  "零陵",  "新田",  "宁远",  "蓝山",  "双牌",  "江永",  "道县",  "东安",  "江华",  "新宁",  "武冈",  "隆回",  "绥宁",  "洞口",  "城步",  "娄底",  "涟源",  "新邵",  "双峰",  "冷水江",  "邵东",  "新化",  "怀化",  "黔阳",  "辰溪",  "沅陵",  "溆浦",  "会同",  "靖县",  "洪江",  "芷江",  "麻阳",  "通道",  "新晃",  "吉首",  "永顺",  "桑植",  "大庸",  "古丈",  "泸溪",  "凤凰",  "花垣",  "保靖",  "龙山",  "常德",  "临澧",  "澧县",  "安乡",  "津市",  "汉寿",  "桃源",  "慈利",  "石门",  "益阳",  "南县",  "沅江",  "宁乡",  "安化",  "桃江"],
            ["海口",  "琼山",  "文昌",  "定安",  "琼海",  "万宁",  "屯昌",  "澄迈",  "儋县",  "临高",  "保亭",  "白沙",  "琼中",  "陵水",  "崖县",  "乐东",  "东方",  "昌江"],
            ["南宁",  "柳州",  "桂林",  "梧州",  "凭祥",  "邕宁",  "武鸣",  "马山",  "上林",  "宾阳",  "横县",  "扶绥",  "崇左",  "宁明",  "龙州",  "大新",  "天等",  "隆安",  "河池",  "环江",  "罗城",  "宜山",  "东兰",  "凤山",  "天峨",  "南丹",  "都安",  "巴马",  "合山",  "柳城",  "融安",  "鹿寨",  "象州",  "武宜",  "柳江",  "来宾",  "忻城",  "融水",  "三江",  "金秀",  "临桂",  "灵川",  "兴安",  "资源",  "全州",  "灌阳",  "恭城",  "平乐",  "荔浦",  "永福",  "龙胜",  "苍悟",  "钟山",  "富川",  "贺县",  "岑溪",  "藤县",  "蒙山",  "昭平",  "玉林",  "桂平",  "平南",  "容县",  "北流",  "陆川",  "博白",  "贵县",  "北海",  "钦州",  "灵山",  "浦北",  "合浦",  "上思",  "防城",  "百色",  "凌云",  "乐业",  "田阳",  "田东",  "平果",  "德保",  "靖西",  "那坡",  "西林",  "田林",  "隆林"],
            ["成都",  "金堂",  "双流",  "蒲江",  "郫县",  "新都",  "来易",  "盐边",  "温江",  "灌县",  "彭县",  "什邡",  "广汉",  "新津",  "邛崃",  "大邑",  "崇庆",  "绵阳",  "江油",  "青川",  "平武",  "光元",  "旺苍",  "剑阁",  "梓潼",  "三台",  "盐亭",  "射洪",  "遂宁",  "蓬溪",  "中江",  "德阳",  "绵竹",  "安县",  "北川",  "内江",  "乐至",  "安岳",  "威远",  "资中",  "资阳",  "简阳",  "隆昌",  "宜宾",  "富顺",  "南溪",  "江安",  "纳溪",  "泸县",  "合江",  "泸州",  "古蔺",  "叙水",  "长宁",  "兴文",  "琪县",  "高县",  "筠连",  "屏由",  "乐由",  "夹江",  "洪雅",  "丹棱",  "青神",  "眉由",  "彭由",  "井研",  "仁寿",  "犍为",  "沐川",  "娥眉",  "马边",  "峨边",  "金口",  "涪陵",  "垫江",  "丰都",  "石柱",  "秀山",  "西阳",  "黔江",  "彭水",  "武隆",  "南川",  "万县",  "开县",  "城口",  "巫溪",  "巫山",  "奉节",  "云阳",  "忠县",  "梁平",  "南允",  "苍溪",  "阆中",  "仪陇",  "南部",  "西允",  "营山",  "蓬安",  "广安",  "岳池",  "武胜",  "华云",  "达县",  "万源",  "宜汉",  "开江",  "邻水",  "大竹",  "渠县",  "南江",  "巴中",  "平昌",  "通江",  "百沙",  "雅安",  "芦山",  "名山",  "荣经",  "汉源",  "石棉",  "天全",  "宝兴",  "马尔康",  "红原",  "阿坝",  "若尔盖",  "黑水",  "松潘",  "南坪",  "汶川",  "理县",  "小金",  "金川",  "壤塘",  "茂汶",  "康定",  "炉霍",  "甘孜",  "新龙",  "白玉",  "德格",  "石渠",  "色达",  "泸定",  "丹巴",  "九龙",  "雅江",  "道孚",  "理塘",  "乡城",  "稻城",  "巴塘",  "得荣",  "西昌",  "昭觉",  "甘洛",  "雷波",  "宁南",  "会东",  "会理",  "德昌",  "美姑",  "金阳",  "布拖",  "普格",  "喜德",  "越西",  "盐源",  "冕宁",  "木里"],
            ["贵阳",  "六盘水",  "水城",  "盘县",  "六枝",  "遵义",  "绥阳",  "道真",  "凤冈",  "余庆",  "赤水",  "桐梓",  "正安",  "务川",  "湄潭",  "仁怀",  "习水",  "铜仁",  "玉屏",  "思南",  "德江",  "万山",  "江口",  "师阡",  "印江",  "沿河",  "松桃",  "毕节",  "黔西",  "织金",  "赫章",  "大方",  "金沙",  "钠雍",  "威宁",  "安顺",  "息烽",  "清镇",  "普定",  "开阳",  "修文",  "平坝",  "镇宁",  "紫云",  "关岭",  "兴义",  "普安",  "贞丰",  "望谟",  "册亭",  "安龙",  "兴仁",  "晴龙",  "凯里",  "施秉",  "镇远",  "天柱",  "剑河",  "黎平",  "从江",  "麻江",  "黄平",  "三穗",  "岑巩",  "锦屏",  "台江",  "榕江",  "雷山",  "丹寨",  "都匀",  "贵定",  "瓮安",  "平塘",  "长顺",  "惠水",  "荔波",  "福泉",  "独山",  "罗甸",  "龙里",  "三都"],
            ["昆明",  "富民",  "晋宁",  "呈贡",  "安宁",  "昭通",  "永善",  "大关",  "彝良",  "鲁甸",  "绥江",  "盐津",  "威信",  "镇雄",  "巧家",  "永富",  "曲靖",  "宣威",  "富源",  "师宗",  "嵩明",  "会泽",  "沽益",  "罗平",  "陆良",  "宜良",  "马龙",  "路南",  "寻甸",  "玉溪",  "华宁",  "通海",  "澄江",  "江川",  "易门",  "元江",  "新平",  "峨山",  "思茅",  "普洱",  "镇沅",  "景东",  "景谷",  "黑江",  "澜沦",  "西盟",  "江城",  "孟连",  "临沦",  "云县",  "镇康",  "永德",  "凤庆",  "双江",  "沧源",  "耿马",  "保由",  "施甸",  "腾冲",  "昌宁",  "龙陵",  "丽江",  "华坪",  "永胜",  "宁蒗",  "文山",  "广南",  "西畴",  "麻栗坡",  "马关",  "丘北",  "砚山",  "富宁",  "个旧",  "弥勒",  "蒙自",  "元阳",  "红河",  "石屏",  "泸西",  "金平",  "开远",  "绿春",  "建水",  "河口",  "屏边",  "景淇",  "勐海",  "勐腊",  "楚雄",  "元谋",  "武定",  "禄丰",  "南华",  "大姚",  "永仁",  "禄劝",  "牟定",  "双柏",  "姚安",  "下关",  "剑川",  "洱源",  "宾川",  "弥渡",  "永平",  "鹤庆",  "大理",  "漾濞",  "云龙",  "祥云",  "巍山",  "南涧",  "潞西",  "陇川",  "盈江",  "畹町",  "瑞丽",  "梁河",  "泸水",  "碧江",  "福贡",  "兰坪",  "贡山",  "中甸",  "德钦",  "维西",  "拉萨",  "林周",  "当雄",  "墨竹工卡",  "尼木",  "米林",  "墨脱",  "达孜",  "曲水",  "堆龙德庆",  "林芝",  "工布江达",  "那曲",  "巴青",  "比如",  "班戈",  "嘉黎",  "聂荣",  "索县",  "安多",  "申扎",  "吕都",  "贡觉",  "左贡",  "察隅",  "洛隆",  "丁青",  "波密",  "江达",  "察雅",  "芒康",  "八宿",  "边坝",  "类乌齐",  "乃东",  "加查",  "曲松",  "错那",  "穷结",  "贡嘎",  "浪卡子",  "桑日",  "朗县",  "隆子",  "措美",  "洛扎",  "扎囊",  "日喀则",  "定结",  "拉孜",  "聂拉木",  "谢通门",  "仲巴",  "康马",  "亚东",  "岗巴",  "南木林",  "萨迦",  "定日",  "吉隆",  "昂仁",  "江孜",  "仁布",  "白朗",  "萨嘎",  "噶尔",  "革吉",  "扎达",  "措勤",  "日上",  "改则",  "普兰"],
            ["西安",  "长安",  "铜川",  "耀县",  "宝鸡",  "凤翔",  "千阳",  "陇县",  "麟游",  "岐山",  "浮风",  "武功",  "眉县",  "太白",  "凤县",  "榆林",  "神木",  "府谷",  "佳县",  "米脂",  "吴堡",  "绥德",  "清涧",  "子洲",  "横山",  "靖边",  "定边",  "延安",  "安寨",  "子长",  "延川",  "延长",  "宜川",  "黄龙",  "洛川",  "宜君",  "黄陵",  "富县",  "甘泉",  "志丹",  "吴旗",  "咸阳",  "礼泉",  "永寿",  "彬县",  "长武",  "旬邑",  "淳化",  "泾阳",  "三原",  "高陵",  "户县",  "周至",  "兴平",  "乾县",  "渭南",  "蒲城",  "白水",  "成城",  "韩城",  "合阳",  "人荔",  "潼关",  "华阴",  "华县",  "蓝田",  "临潼",  "富平",  "商县",  "洛南",  "丹凤",  "商南",  "山阳",  "镇安",  "柞水",  "安康",  "旬阳",  "白河",  "平利",  "镇坪",  "岚皋",  "紫阳",  "汉阴",  "石泉",  "宁陕",  "汉中",  "留坝",  "城固",  "洋县",  "佛坪",  "西乡",  "镇巴",  "南郑",  "宁强",  "勉县",  "略阳"],
            ["兰州",  "永登",  "榆中",  "永昌",  "皋兰",  "定西",  "会宁",  "陇西",  "临洮",  "靖远",  "通渭",  "渭源",  "平凉",  "灵台",  "华亭",  "静宁",  "泾川",  "崇信",  "庄浪",  "庆阳",  "华池",  "庄宁",  "镇源",  "环县",  "合水",  "宁县",  "天水",  "徽县",  "礼县",  "武山",  "秦安",  "清水",  "两当",  "西和",  "甘谷",  "漳县",  "张家川",  "武都",  "宕昌",  "康县",  "成县",  "文县",  "临潭",  "舟曲",  "玛曲",  "下河",  "卓尼",  "迭部",  "碌曲",  "临夏",  "永靖",  "和政",  "康乐",  "广河",  "东乡",  "岷县",  "积石山",  "武威",  "民勤",  "古浪",  "景泰",  "天祝",  "张掖",  "民乐",  "临泽",  "山丹",  "高台",  "肃南",  "玉门",  "酒泉",  "敦煌",  "金塔",  "安西",  "阿克塞",  "肃北"],
            ["西宁",  "大通",  "平安",  "湟中",  "乐都",  "民和",  "湟源",  "互助",  "化隆",  "循化",  "门源",  "海晏",  "刚察",  "祁连",  "同仁",  "尖扎",  "泽库",  "河南",  "共和",  "贵德",  "贵南",  "同德",  "兴海",  "玛沁",  "甘德",  "久治",  "班玛",  "达日",  "玛多",  "玉树",  "称多",  "囊谦",  "杂多",  "治多",  "曲麻菜",  "格尔木",  "乌兰",  "都兰",  "天峻",  "银川",  "永宁",  "贺兰",  "石嘴山",  "平罗",  "陶乐",  "吴忠",  "同心",  "灵武",  "中宁",  "盐池",  "中卫",  "青铜峡",  "固原",  "西吉",  "泾源",  "海原",  "隆德"],
            ["乌鲁木齐",  "克拉玛依",  "石河子",  "吐鲁番",  "托克逊",  "鄯善",  "哈密",  "伊吾",  "巴里坤",  "库尔勒",  "和静",  "和硕",  "博湖",  "尉梨",  "轮台",  "焉耆",  "和田",  "民丰",  "策勒",  "于田",  "洛浦",  "皮山",  "墨玉",  "阿克苏",  "温宿",  "拜城",  "库车",  "新和",  "沙雅",  "阿瓦提",  "柯平",  "乌什",  "咯什",  "巴楚",  "枷师",  "乐普湖",  "麦盖提",  "莎车",  "泽普",  "叶城",  "疏勒",  "英吉沙",  "疏附",  "塔什库尔干",  "阿图什",  "阿合奇",  "阿克陶",  "乌恰",  "昌吉",  "阜康",  "奇台",  "吉木萨尔",  "米泉",  "玛纳斯",  "呼图壁",  "木垒",  "博乐",  "精河",  "温泉",  "伊宁",  "尼勒克",  "新源",  "巩留",  "奎屯",  "特克斯",  "昭苏",  "霍城",  "察布察尔",  "塔城",  "额敏",  "乌苏",  "托里",  "裕民",  "沙湾",  "和布克赛尔",  "阿勒泰",  "青河",  "富蕴",  "福海",  "吉木乃",  "布尔津",  "哈巴河"],
            ["广州",  "韶关",  "深圳",  "珠海",  "汕头",  "佛山",  "江门",  "湛江",  "茂名",  "肇庆",  "惠州",  "梅州",  "汕尾",  "河源",  "阳江",  "清远",  "东莞",  "中山",  "潮州",  "揭阳",  "云浮",  "乐昌",  "南雄",  "台山",  "开平",  "鹤山",  "恩平",  "廉江",  "雷州",  "吴川",  "高州",  "化州",  "信宜",  "四会",  "兴宁",  "陆丰",  "阳春",  "英德",  "连州",  "普宁",  "罗定"]
            ],
            sizeForm:{
                date1:'',
                date2:'',
                province:'',
                city:'',
                sex:''
            },
            rules: {
                date1: [
                 { required: true, message: '输入内容不能为空', trigger: 'change' },
                ],
                date2: [
                 { required: true, message: '输入内容不能为空', trigger: 'change' },
                ],
                province: [
                 { required: true, message: '输入内容不能为空', trigger: 'change' },
                ],
                city: [
                 { required: true, message: '输入内容不能为空', trigger: 'change' },
                ],
                sex: [
                 { required: true, message: '输入内容不能为空', trigger: 'change' },
                ],
            },
          bornDate:[1988, 8, 6, 9],
          daziArray:['戊', '辰', '己', '未', '癸', '巳', '丁', '巳'],
          kongwangArray:['午', '未'],
          dayunArray:[{'庚申':1999}, {'辛酉': 2009}, {'壬戌':2019}, {'癸亥': 2029}, {'甲子':2039}, {'乙丑':2049}, {'丙寅':2059}],
          cangArray:[['乙', '戊', '癸'], ['乙', '己', '丁'], ['丙', '戊', '庚'], ['丙', '戊', '庚']],
          baziGodArray:['正官', '正官', '偏官', '偏官', '偏财', '偏财', '偏财'],
          cangGodArray:[['食神', '正官', '比肩'], ['食神', '偏官', '偏财'], ['正财', '正官', '正印'], ['正财', '正官', '正印']],
          baziWangArray:['旺', '旺', '旺', '旺', '衰', '旺', '旺', '旺'],
          provincecity: '',
          showArea: false,
          areaList,// 数据格式见 Area 组件文档
          datetime: '',
          showPicker: false,
          showPicker2: false,
          minDate: new Date(1910, 0, 1),
          maxDate: new Date(2030, 10, 1),
          currentDate: new Date(1990, 0, 1),
          sex: '女',
          codeFlag:'',
          userInfo:{}
        }
  },
  computed:{
    cityFilterList(){
      return this.cityList[this.sizeForm.province]
    },
    userinfoLove() {
      // 通过vuex的getters方法来获取state里面的数据
      return this.$store.getters.getUserinfoLove || {};
    },
    openid() {
      // 通过vuex的getters方法来获取state里面的数据
      return this.userinfoLove.jsopenid;
    },
    unionid() {
      // 通过vuex的getters方法来获取state里面的数据
      return this.userinfoLove.unionid;
    },
  },
  mounted(){
    const city_list = areaList.city_list
    const city_name = Object.values(city_list) 
    const city_code = Object.keys(city_list) 
    console.log('city_name',city_name.join(","))
    console.log('city_code',city_code.join(","))
    if(!this.openid){
      this.getlogin()
    }
  },
   methods:{
            gotoRecord(){
              this.$router.push({path: '/paipanRecord',query:{openid:this.openid,unionid:this.unionid}})
            },
            onSubmit(){
              if(this.datetime == '' || this.provincecity == ''){
                Toast.fail('输入不能为空');
                return
              }
                let url = '/paipan/submit'
                const city = this.provincecity.split('/')
                const time = this.datetime.split('-')
                const params = {
                    openid:this.openid,
                    unionid:this.unionid,
                    year: time[0],
                    month: time[1],
                    day: time[2],
                    hour: time[3],
                    minute: time[4],
                    sex: this.sex,
                    city: city[1]
                }
                postAction(url,params)
                .then((response) => {
                      console.log( 'responseData', response)
                      console.log('responseData',response.data.context)
                      sessionStorage.setItem("bornDate", JSON.stringify(response.data.context.bornDate))
                      sessionStorage.setItem("birthDay", JSON.stringify(response.data.context.birthDay))
                      sessionStorage.setItem("baziArray", JSON.stringify(response.data.context.baziArray))
                      sessionStorage.setItem("kongwangArray", JSON.stringify(response.data.context.kongwangArray))
                      sessionStorage.setItem("dayunArray", JSON.stringify(response.data.context.dayunArray))
                      sessionStorage.setItem("cangArray", JSON.stringify(response.data.context.cangArray))
                      sessionStorage.setItem("baziGodArray", JSON.stringify(response.data.context.baziGodArray))
                      sessionStorage.setItem("cangGodArray", JSON.stringify(response.data.context.cangGodArray))
                      sessionStorage.setItem("baziWangArray", JSON.stringify(response.data.context.baziWangArray))
                      sessionStorage.setItem("ysdz", JSON.stringify(response.data.context.yswords.dz))
                      sessionStorage.setItem("ystg", JSON.stringify(response.data.context.yswords.tg))
                      sessionStorage.setItem("sex", JSON.stringify(response.data.context.sexArray))
                      sessionStorage.setItem("city", JSON.stringify(response.data.context.cityArray))
                      sessionStorage.setItem("qiyun", JSON.stringify(response.data.context.qiyunArray))
                      this.$router.push({ path: '/paipanResult',query:{date:`${time[0]}-${time[1]}-${time[2]}-${time[3]}-${time[4]}`,city:city[1]}})
                })

            },
            onConfirmCity(values) {
              this.provincecity = values
                .filter((item) => !!item)
                .map((item) => item.name)
                .join('/');
                console.log('values',this.provincecity)
              this.showArea = false;
            },
            onConfirmTime(time) {
              console.log('values',time)
              this.datetime = this.parseTime(time,'{y}-{m}-{d}-{h}-{i}' )
              console.log('values',this.datetime)
              this.showPicker2 = false;
            },
            submitForm(formName) {
               this.$refs[formName].validate((valid) => {
               if (valid) {
                 let yymmddList = this.sizeForm.date1.split('-')
                 console.log('yymmddList',yymmddList)
                 let hhmmssList = this.sizeForm.date2.split('-')
                 console.log('hhmmssList',hhmmssList)
                let url = '/paipan/submit'
                postAction(url, {
                    year: yymmddList[0],
                    month: yymmddList[1],
                    day: yymmddList[2],
                    hour: hhmmssList[0],
                    minute: hhmmssList[1],
                    sex: this.sizeForm.sex,
                    city: this.sizeForm.city
                })
                .then((response) => {
                      console.log( 'responseData', response)
                      console.log('responseData',response.data.context)
                      sessionStorage.setItem("bornDate", JSON.stringify(response.data.context.bornDate))
                      sessionStorage.setItem("birthDay", JSON.stringify(response.data.context.birthDay))
                      sessionStorage.setItem("baziArray", JSON.stringify(response.data.context.baziArray))
                      sessionStorage.setItem("kongwangArray", JSON.stringify(response.data.context.kongwangArray))
                      sessionStorage.setItem("dayunArray", JSON.stringify(response.data.context.dayunArray))
                      sessionStorage.setItem("cangArray", JSON.stringify(response.data.context.cangArray))
                      sessionStorage.setItem("baziGodArray", JSON.stringify(response.data.context.baziGodArray))
                      sessionStorage.setItem("cangGodArray", JSON.stringify(response.data.context.cangGodArray))
                      sessionStorage.setItem("baziWangArray", JSON.stringify(response.data.context.baziWangArray))
                      sessionStorage.setItem("sex", JSON.stringify(response.data.context.sexArray))
                      sessionStorage.setItem("city", JSON.stringify(response.data.context.cityArray))
                      sessionStorage.setItem("qiyun", JSON.stringify(response.data.context.qiyunArray))
                       this.$router.push({ name: 'PaipanResult'})
                })
              } else {
                console.log('error submit!!');
                  return false;
                }
            });
           },
            resetForm(formName) {
              this.$refs[formName].resetFields();
            },
            parseTime (time, cFormat) {
              if (arguments.length === 0) {
                return null
              }
              if (!time) return ''
              const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
              let date
              if (typeof time === 'object') {
                date = time
              } else {
                if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
                  time = parseInt(time)
                }
                if ((typeof time === 'number') && (time.toString().length === 10)) {
                  time = time * 1000
                }
                date = new Date(time)
              }
              const formatObj = {
                y: date.getFullYear(),
                m: date.getMonth() + 1,
                d: date.getDate(),
                h: date.getHours(),
                i: date.getMinutes(),
                s: date.getSeconds(),
                a: date.getDay()
              }
              const timeStr = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
                let value = formatObj[key]
                // Note: getDay() returns 0 on Sunday
                if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
                if (result.length > 0 && value < 10) {
                  value = '0' + value
                }
                return value || 0
              })
              return timeStr
            },
            gotoCode(){
                if(this.isweixin()){
                  console.log(this.isweixin())
                  //window.location.href="https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxbb2af162829dc7fe&redirect_uri=http%3A%2F%2Fzy.miaoxingjundd.cn%2F&response_type=code&scope=snsapi_base&state=123#wechat_redirect"
                  this.codeFlag = true
                  window.location.href="https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxbb2af162829dc7fe&redirect_uri=https%3A%2F%2Fonline.miaoxingjundd.com%2Fpaipan&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect"
                  //  this.$router.push({path:'/reportList', query: {code: "1234"}})
              }
              //  else {
              //     this.$router.push({path:'/reportList', query: {code: "1234"}})
              //  }
            },
            getlogin(){
              if(this.$route.query.code){
                this.getOpenID()
              } else {
                this.gotoCode()
              }
            },
            getOpenID(){
              const url = '/paipan/vxlogin'
              // const url = '/pr/test'
                  postAction(url, {code:this.$route.query.code}).then( res => {
                    this.userInfo = res.data.data
                    console.log(this.userInfo)
                    this.$store.commit('setUserInfoLove', this.userInfo)
                    // this.openid = res.data.data.openid;
                    // this.unionid = res.data.data.unionid;
                    // this.$store.dispatch("setopenidval", this.userInfo.openid);
                    // this.$store.dispatch("setunionidval", this.userInfo.unionid);
                  })
            },
            isweixin(){
              var ua = window.navigator.userAgent.toLowerCase();
                if (ua.match(/MicroMessenger/i) == 'micromessenger') {
                    return true
                } else {
                    return false
                }
            },
   }
};
</script>
<style>
.container {
   text-align: justify;
   width: 100%;
   max-width: 800px;
   margin-right: auto;
   margin-left: auto;
   /* padding-left: 16px;
   padding-right: 16px; */
}
.el-form-item__label{
  font-weight: bold;
  font-size: 0.9em ;
}
.el-form--label-top .el-form-item__label {
    float: none;
    display: inline-block;
    text-align: left;
    padding: 0px;
}
.el-form-item__content{
  font-size: 0.95em ;
}
</style>
